// extracted by mini-css-extract-plugin
export default {"FormTitle":"style_FormTitle__l-10S","title":"style_title__35ALD"};